import { Card, CardBody } from "@heroui/react";
import { formatDate } from "date-fns";
import { type ReactNode } from "react";

import logo from "../../assets/logo.webp";
import { useCountdown } from "../../hooks/useCountdown";
import { EVENT_NAME } from ".";
import { useEventDates } from "./useEventDates";

export const EventDatesHeader = () => {
  const { state, start, end } = useEventDates();

  if (state === "UNKNOWN")
    return <>{import.meta.env.DEV && "Dev: event.dates is not set"}</>;

  switch (state) {
    case "BEFORE":
      return <BeforeEvent start={start!} />;
    case "DURING":
      return <DuringEvent end={end!} />;
    case "AFTER":
      return <AfterEvent start={start!} end={end!} />;
  }
};

const BeforeEvent = ({ start }: { start: number }) => {
  const { timeLeft } = useCountdown(start);

  return (
    <EventHeaderCard>
      Starts in <span className="font-semibold">{timeLeft}</span>
    </EventHeaderCard>
  );
};

const DuringEvent = ({ end }: { end: number }) => {
  const { timeLeft } = useCountdown(end);

  return (
    <EventHeaderCard>
      Ends in <span className="font-semibold">{timeLeft}</span>
    </EventHeaderCard>
  );
};

const AfterEvent = ({ start, end }: { start: number; end: number }) => {
  return (
    <EventHeaderCard>
      <strong>
        {formatDate(start, "MMM do @ h:mm a")} -{" "}
        {formatDate(end, "MMM do @ h:mm a")}
      </strong>
    </EventHeaderCard>
  );
};

const EventHeaderCard = ({ children }: { children: ReactNode }) => {
  return (
    <Card className="canvas-overlay-card event-dates-header-card">
      <CardBody className="event-dates-header-card-body">
        <img className="event-dates-header-logo" src={logo} alt="" />
        <div className="event-dates-header-copy">
          <h2>{EVENT_NAME}</h2>
          <h3>{children}</h3>
        </div>
      </CardBody>
    </Card>
  );
};
